import { render, staticRenderFns } from "./GoTo.vue?vue&type=template&id=5c40fd37&scoped=true&lang=html"
import script from "./GoTo.vue?vue&type=script&lang=js"
export * from "./GoTo.vue?vue&type=script&lang=js"
import style0 from "./GoTo.vue?vue&type=style&index=0&id=5c40fd37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40fd37",
  null
  
)

export default component.exports